import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { useFormikContext } from 'formik';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import AccordionPersonForm from './form';
import { RegistrationBewareFormVM, PersonVM } from 'mutation/view-models/registration-beware';
import { useBus, useListener } from 'shell/hooks/use-bus';

interface AccordionPersonProps {
  disabled?: boolean;
  onSearch: (values?: PersonVM | null) => Promise<RegistrationBewareFormVM>;
  isBeware?: boolean;
}

const AccordionPersonComponent = ({
  disabled,
  onSearch,
  isBeware,
}: AccordionPersonProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<RegistrationBewareFormVM>();

  useListener<boolean>('OPEN_CLOSE_SEARCH', (openSearchParam) => {
    const openSearch = openSearchParam || false;
    setOpen(openSearch);
  });

  const dispatch = useBus();

  const onFieldPersonChange = useEventCallback(
    (key: keyof PersonVM, value: PersonVM[keyof PersonVM]) => {
      formContext.setFieldValue('searchPerson', {
        ...(formContext.values?.searchPerson || {}),
        [key]: value,
      });
    }
  );

  const onFieldPersonChanges = useEventCallback((value: PersonVM) => {
    const { subjectAttributes, ...otherValues } = value;
    formContext.setValues({
      ...(formContext.values || {}),
      subjectAttributes: {
        ...(formContext.values?.subjectAttributes || {}),
        ...(subjectAttributes || {}),
        disabled: value ? false : true, // selezionato l'elemento si abilitano i campi
      },
      searchPerson: {
        ...(formContext.values?.searchPerson || {}),
        ...(otherValues || {}),
      },
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Cerca Persona</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionPersonForm
            disabled={disabled}
            values={formContext.values?.searchPerson}
            onChange={onFieldPersonChange}
            onChanges={onFieldPersonChanges}
            isBeware={isBeware}
            onSearch={(values) =>
              onSearch(values).then((response) => {
                if (!response.person?.personsList) {
                  dispatch.emit('OPEN_CLOSE_SEARCH', false);
                }
              })
            }
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionPersonComponent.displayName = 'Accordion person component';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
